var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"chips-wrapper mb-3",attrs:{"cols":"12"}},[_c('v-row',{staticClass:"nowrap"},[_c('v-col',{staticClass:"py-0"},[_c('FiltersChips',{attrs:{"presets":_vm.filterPresets,"clickable":"","reset-filter":_vm.resetFilter}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }